import { INewCardLocalStorage, NEW_CARD_LOCALSTORAGE } from '../types';

export const setNewCardLocalStorage = (
    newCardLocalStorage: INewCardLocalStorage
) => {
    localStorage.setItem(NEW_CARD_LOCALSTORAGE, JSON.stringify(newCardLocalStorage));
}
